import React from "react"

export default function FieldGoalType_FormValueNotEmpty(props:any) {

    const {option} = props;
    let label = option.label;

    const optionColor = _.get(option, 'color', null); //!_.isNil(option.color) ? option.color : null;
    if (optionColor) {
        const pillClasses = Classes("gd-c-font-{0}".f(optionColor));
        label = <div className={pillClasses}>{option.label}</div>;
    }

    const height = props.className?.includes(' h-') ? '' : 'h-36' // default height if not set externally

    const valueClasses = Classes("ui5-field-form-editable dropdown-form not-selectable", height, props.className, {
        'colored-value-selected'            : !!optionColor
    })

    const labelClasses = Classes('lh-20 txt-truncate', {
        'ui5-txt-default'       : !props.disabled,
        'ui5-txt-no-accent-default'     : props.disabled,
    })

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                <div className={Classes("ui5-ico-14 m-r-8", option.icon)}/>
                <div className={labelClasses}>{label}</div>
            </div>
            {props.children}
        </React.Fragment>
    );
}